import { InjectionToken } from '@angular/core';

import { FEATURE_FLAG, FeatureFlags } from './feature-flag.model';

/** Sections not released yet stay hidden; a ticket turns its flag on when the section ships. */
export const FEATURE_FLAG_DEFAULTS: FeatureFlags = {
  [FEATURE_FLAG.SHOWCASE]: false,
  [FEATURE_FLAG.HOME]: false,
  [FEATURE_FLAG.TEAM]: false,
  [FEATURE_FLAG.PARTNER_DETAILS]: false,
};

export const FEATURE_FLAGS = new InjectionToken<FeatureFlags>('FEATURE_FLAGS', {
  providedIn: 'root',
  factory: () => FEATURE_FLAG_DEFAULTS,
});
